
import { EProjectStatus } from '@/helpers/enums'

export default {
  name: 'Results',

  props: {
    showColumns: Boolean,
    results: {
      type: Array,
      required: true
    },
    resultsTotal: {
      type: Number,
      required: true
    },
    offset: {
      type: Number,
      required: true
    },
    totalVisible: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      savePath: ''
    }
  },

  computed: {
    checkedClientAndPage() {
      const checkedPage = this.$route.name.includes('projects-pool')
      return checkedPage
    },

    isPossibleToApply() {
      const projectsClosed = this.results?.filter((e) => e.status !== EProjectStatus.ACTIVE)
      return projectsClosed.length !== this.results.length
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler({ fullPath }) {
        this.savePath = fullPath
      }
    },

    '$store.state.locale': {
      immediate: true,
      handler(newLocale) {
        const momentLocale = newLocale.includes('-') ? newLocale.split('-')[0] : newLocale
        this.$moment.locale(momentLocale)
      }
    }
  },

  beforeDestroy() {
    localStorage.setItem('backPathUri', this.savePath)
  }
}
